import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as MenuIcon } from "../../assets/svgs/menu-icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/svgs/close-icon.svg";
import { ReactComponent as TagsIcon } from "../../assets/svgs/tags-icon.svg";
import { ReactComponent as MeasurementIcon } from "../../assets/svgs/icons/measurement-icon.svg";
import { ReactComponent as ControlIcon } from "../../assets/svgs/icons/control-icon.svg";
import { ReactComponent as ClassificationIcon } from "../../assets/svgs/icons/classification-icon.svg";
import Tags from "./Tags/Tags";
import MenuBarIcon from "../MenuBarIcon/MenuBarIcon";
import { MenubarContainer } from "./Menubar.style";
import Measurement from "./Measurement/Measurement";
import CameraControl from "./CameraControl/CameraControl";
import Classification from "./Classification/Classification";
import { useSnapshot } from "valtio";
import { Store } from "../../store/Store";
import MapToggleBar from "./MapToggleBar";

interface Menu {
  icon: JSX.Element;
  menuId: string;
}

export default function Menubar() {
  const snap = useSnapshot(Store);
  const [isShow, setIsShow] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isMenuCardOpen, setIsMenuCardOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);
  const menuIconRef = useRef<HTMLDivElement>(null);

  const MenuList: Menu[] = [
    { icon: <MeasurementIcon key="measurement" />, menuId: "measurement" },
    { icon: <ControlIcon key="cameraControl" />, menuId: "cameraControl" },
    { icon: <TagsIcon key="tags" />, menuId: "tags" },
    { icon: <ClassificationIcon key="classification" />, menuId: "classification"}
  ];

  const handleMenuHover = (menuId: string) => {
    setActiveMenu(menuId);
    setIsMenuCardOpen(true);
    setIsShow(true);
  };

  const toggleMenuBar = () => {
    if(isShow) {
      setIsMenuCardOpen(false);
      setActiveMenu(null);
    }
    setIsShow(!isShow);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      cardRef.current &&
      !cardRef.current.contains(event.target as Node) &&
      menuIconRef.current &&
      !menuIconRef.current.contains(event.target as Node)
    ) {
      setIsMenuCardOpen(false);
      setActiveMenu(null);
      setIsShow(false);
    }
  };


  useEffect(() => {
    localStorage.setItem("classificationState","");
    const sideBar = document.getElementById("potree_sidebar_container");
    if (!snap.uiState.isPotreeMenu) {
      const quickButtonsElement = document.getElementById(
        "potree_quick_buttons"
      );
      if (quickButtonsElement) {
        quickButtonsElement.style.display = "none";
      }
      if (sideBar) {
        sideBar.style.display = "none";
      }
    }else {
      if (sideBar) {
        sideBar.style.display = "block";
      }
    }
  }, [snap.isInitialized]);

  // Move potree map element based on active menu
  useEffect(() => {
    const potreeMapElement = document.getElementById("potree_map");
    const tagsComponent = document.querySelector(".tag_sections") as HTMLElement | null;
    const controlComponent = document.querySelector(".control_sections") as HTMLElement | null;
    const measurementComponent = document.querySelector(".measurement_sections") as HTMLElement | null;
    const classificationComponent = document.querySelector(".classification_sections") as HTMLElement | null;
  
    if (potreeMapElement) {
      let totalWidth = 0;
      if (activeMenu === "tags" && tagsComponent) {
        totalWidth = tagsComponent.offsetWidth;
      } else if (activeMenu === "cameraControl" && controlComponent) {
        totalWidth = controlComponent.offsetWidth;
      } else if (activeMenu === "measurement" && measurementComponent) {
        totalWidth = measurementComponent.offsetWidth;
      } else if (activeMenu === "classification" && classificationComponent) {
        totalWidth = classificationComponent.offsetWidth;
      }
  
      let leftPosition = 110;
      if (activeMenu) {
        leftPosition += totalWidth;
      } else {
        leftPosition = 80;
      }
  
      potreeMapElement.style.left = `${leftPosition}px`;
    }
  }, [activeMenu]);

  return (
    <>
      <MenubarContainer>
        {!snap.uiState.isPotreeMenu && (
          <>
            <div className="menu-container">
              <MapToggleBar />
              <div className="menubar_container_wrapper">
                <div className="menubar_wrapper">
                  <div className="menubar_sections">
                    <div className="menubar_button">
                      {isShow ? (
                        <CloseIcon onClick={toggleMenuBar} />
                      ) : (
                        <MenuIcon onClick={toggleMenuBar} />
                      )}
                      {isShow && (
                        <div ref={menuIconRef} className="menu_icons">
                          {MenuList.map(({ icon, menuId }) => (
                            <MenuBarIcon
                              key={menuId}
                              icon={icon}
                              onHover={handleMenuHover}
                              activeMenuItem={activeMenu}
                              menuItem={menuId}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {isMenuCardOpen && (
                  <div ref={cardRef}>
                    {activeMenu === "measurement" && <Measurement />}
                    {activeMenu === "cameraControl" && <CameraControl />}
                    {activeMenu === "tags" && <Tags setActiveMenu={setActiveMenu} />}
                    {activeMenu === "classification" && <Classification />}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </MenubarContainer>
    </>
  );
}
